import React from 'react'
import { Male, Female } from '../icons'

const GenderChart = ({male, female}) => {
  const total = male + female;
  const malePercent = male/total*100
  const femalePercent = female/total*100

  // Adjustable. choose between .ceil and .floor
  const maleCount = Math.ceil(malePercent/10)
  const femaleCount = Math.floor(femalePercent/10)

  const males = []
  const females = []

  for (let i = 0; i < maleCount; i++) {
    males.push(<Male style={{marginRight: '5px'}} key={i} color="#52BAE2" />)
  }

  for (let i = 0; i < femaleCount; i++) {
    females.push(<Female style={{marginRight: '5px'}} key={i} color="#FF5448" />)
  }

  return (
    <div>
      <div className="flex items-center">
        {
          males.map(m => m)
        }
        {
          females.map(f => f)
        }
      </div>
      {/* {JSON.stringify(maleCount)}<br />
      {JSON.stringify(femaleCount)}<br />
      {JSON.stringify(total)}<br />
      <Female color="#FF5448"/> */}
    </div>
  )
}

export { GenderChart }